import React from "react";
import GetNucleoFamiliar from "../../../components/portal/formsnucleofamiliar/GetNucleoFamiliar";
import { Box, Container } from "@mui/material";
import logo from "./../../../img/logore.png";

const Nucleofamiliar = () => {
  return (
    <Container>
      <Box
        sx={{
          display: { xs: "none", sm: "none", md: "flex", lg: "flex" },
        }}
      >
        <img
          src={logo}
          alt="logo"
          style={{
            width: "10%",
            height: "auto", // Reemplaza con la URL de tu imagen de fondo
            marginTop: "40px",
            marginLeft: "30px",
            position: "absolute",
          }}
        />
      </Box>
      <GetNucleoFamiliar />
    </Container>
  );
};

export default Nucleofamiliar;
